module.exports = __webpack_public_path__ + "images/billboard2-8449bbe3f4d8437e3575d2c2faed17b4.jpg";